import React from "react";

import { string, bool } from "prop-types";

const Twitter = ({ color1 = "#eee", color2 = "#222" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    <g data-name="Group 4660" transform="translate(-484 -1238)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(484 1238)" fill={color1} />
      <g data-name="Group 4650">
        <g data-name="Group 583">
          <path
            d="M505.695 1247.173a6.631 6.631 0 01-1.833.5 3.163 3.163 0 001.4-1.758 6.356 6.356 0 01-2.017.77 3.18 3.18 0 00-5.5 2.175 3.275 3.275 0 00.074.725 9 9 0 01-6.558-3.324 3.181 3.181 0 00.977 4.251 3.141 3.141 0 01-1.437-.392v.035a3.2 3.2 0 002.549 3.126 3.174 3.174 0 01-.834.1 2.812 2.812 0 01-.6-.054 3.211 3.211 0 002.965 2.219 6.39 6.39 0 01-3.939 1.356 5.958 5.958 0 01-.761-.043 8.954 8.954 0 004.879 1.422 8.99 8.99 0 009.052-9.05c0-.141 0-.276-.012-.411a6.345 6.345 0 001.595-1.647z"
            data-name="Path 15"
            fill={color2}
          />
        </g>
      </g>
    </g>
  </svg>
);

Twitter.propTypes = {
  color1: string,
  color2: string
};
const TwitterIcon = ({ color1 = "#3f99ff", color2 = "#fff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    <g data-name="Group 4660" transform="translate(-484 -1238)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(484 1238)" fill={color1} />
      <g data-name="Group 4650">
        <g data-name="Group 583">
          <path
            d="M505.695 1247.173a6.631 6.631 0 01-1.833.5 3.163 3.163 0 001.4-1.758 6.356 6.356 0 01-2.017.77 3.18 3.18 0 00-5.5 2.175 3.275 3.275 0 00.074.725 9 9 0 01-6.558-3.324 3.181 3.181 0 00.977 4.251 3.141 3.141 0 01-1.437-.392v.035a3.2 3.2 0 002.549 3.126 3.174 3.174 0 01-.834.1 2.812 2.812 0 01-.6-.054 3.211 3.211 0 002.965 2.219 6.39 6.39 0 01-3.939 1.356 5.958 5.958 0 01-.761-.043 8.954 8.954 0 004.879 1.422 8.99 8.99 0 009.052-9.05c0-.141 0-.276-.012-.411a6.345 6.345 0 001.595-1.647z"
            data-name="Path 15"
            fill={color2}
          />
        </g>
      </g>
    </g>
  </svg>
);

TwitterIcon.propTypes = {
  color1: string,
  color2: string
};

const Facebook = ({ color1 = "#eee", color2 = "#121212" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" className="facebook-icon">
    <g data-name="Group 3683" transform="translate(-451 -410)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(451 410)" fill={color1} />
      <path
        d="M468.01 424.875l.389-2.534h-2.434V420.7a1.267 1.267 0 011.428-1.369h1.105v-2.16a13.478 13.478 0 00-1.962-.171 3.093 3.093 0 00-3.311 3.41v1.931H461v2.534h2.226V431h2.739v-6.125z"
        data-name="Path 182"
        fill={color2}
      />
    </g>
  </svg>
);

Facebook.propTypes = {
  color1: string,
  color2: string
};

const FacebookIcon = ({ bgcolor = "#3a5998", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" className="facebook-icon">
    <g data-name="Group 3683" transform="translate(-451 -410)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(451 410)" fill={bgcolor} />
      <path
        d="M468.01 424.875l.389-2.534h-2.434V420.7a1.267 1.267 0 011.428-1.369h1.105v-2.16a13.478 13.478 0 00-1.962-.171 3.093 3.093 0 00-3.311 3.41v1.931H461v2.534h2.226V431h2.739v-6.125z"
        data-name="Path 182"
        fill={color}
      />
    </g>
  </svg>
);

FacebookIcon.propTypes = {
  bgcolor: string,
  color: string
};
const Share = ({ color1 = "#0099ff", color2 = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" className="share">
    <g data-name="Group 3795" transform="translate(-544 -128)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(544 128)" fill={color1} />
      <g data-name="Group 3442">
        <path
          d="M549.753 147.667c2.083-2.917 5-4.25 9.167-4.25v3.417l5.833-5.834-5.833-5.833v3.333c-5.834.834-8.334 5-9.167 9.167z"
          data-name="Path 156"
          fill={color2}
        />
        <path d="M567.253 151h-20v-20h20z" data-name="Path 157" fill="none" />
      </g>
    </g>
  </svg>
);

Share.propTypes = {
  color1: string,
  color2: string
};

const FontIncrease = ({ lang, fontIncHover = false }) =>
  lang === "en" ? (
    !fontIncHover ? (
      <svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 28 28">
        <circle id="Ellipse_3" cx="14" cy="14" r="13.5" fill="#eee" />
        <path
          fill="#121212"
          d="M8.758 8.312L4.524 19.688h2.492l.781-2.344h4.109l.789 2.344h2.491L10.93 8.312H8.758zm-.328 7.133l1.414-4.258 1.43 4.258H8.43zM20.656 13.32v-3.054h-2.149v3.054h-2.828v2.039h2.828v3.188h2.149v-3.188h2.82V13.32z"
        />
      </svg>
    ) : (
      <svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 28 28">
        <path
          d="M14 1.5c6.9 0 12.5 5.6 12.5 12.5S20.9 26.5 14 26.5 1.5 20.9 1.5 14 7.1 1.5 14 1.5m0-1C6.5.5.5 6.5.5 14s6 13.5 13.5 13.5 13.5-6 13.5-13.5S21.5.5 14 .5z"
          fill="#e2e2e2"
          id="Ellipse_3"
        />
        <path
          fill="#121212"
          d="M8.758 8.312L4.524 19.688h2.492l.781-2.344h4.109l.789 2.344h2.491L10.93 8.312H8.758zm-.328 7.133l1.414-4.258 1.43 4.258H8.43zM20.656 13.32v-3.054h-2.149v3.054h-2.828v2.039h2.828v3.188h2.149v-3.188h2.82V13.32z"
        />
      </svg>
    )
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23">
      <text
        data-name="অ+"
        transform="translate(1 17)"
        fill="#121212"
        fontSize="14"
        fontFamily="KohinoorBangla-Bold,Kohinoor Bangla"
        fontWeight="300"
      >
        <tspan x="0" y="0">
          অ
        </tspan>
        <tspan y="0" fontFamily="Helvetica-Bold,Helvetica">
          +
        </tspan>
      </text>
    </svg>
  );

FontIncrease.propTypes = {
  lang: string,
  fontIncHover: bool
};

const FontDecrease = ({ lang, fontDecHover = false }) =>
  lang === "en" ? (
    !fontDecHover ? (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <circle cx="14" cy="14" r="13.5" fill="#eee" />
        <path d="M10.25 8.313L6.016 19.687h2.492l.781-2.344h4.109l.789 2.344h2.492L12.422 8.313H10.25zm-.328 7.133l1.414-4.258 1.43 4.258H9.922zM17.586 13.906h4.398v1.82h-4.398z" />
      </svg>
    ) : (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path
          d="M14 1.5c6.9 0 12.5 5.6 12.5 12.5S20.9 26.5 14 26.5 1.5 20.9 1.5 14 7.1 1.5 14 1.5m0-1C6.5.5.5 6.5.5 14s6 13.5 13.5 13.5 13.5-6 13.5-13.5S21.5.5 14 .5z"
          fill="#e2e2e2"
        />
        <path d="M10.25 8.313L6.016 19.687h2.492l.781-2.344h4.109l.789 2.344h2.492L12.422 8.313H10.25zm-.328 7.133l1.414-4.258 1.43 4.258H9.922zM17.586 13.906h4.398v1.82h-4.398z" />
      </svg>
    )
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23">
      <text
        data-name="অ+"
        transform="translate(1 17)"
        fill="#121212"
        fontSize="14"
        fontFamily="KohinoorBangla-Bold,Kohinoor Bangla"
        fontWeight="300"
      >
        <tspan x="0" y="0">
          অ
        </tspan>
        <tspan y="0" fontFamily="Helvetica-Bold,Helvetica">
          -
        </tspan>
      </text>
    </svg>
  );

FontDecrease.propTypes = {
  lang: string,
  fontDecHover: bool
};

const CommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      d="M14 0H2a2 2 0 00-2 2v9a2 2 0 002 2h3v2.625a.374.374 0 00.375.375.36.36 0 00.222-.075L9.5 13H14a2 2 0 002-2V2a2 2 0 00-2-2zm.5 11a.5.5 0 01-.5.5H9l-.4.3-2.1 1.575V11.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h12a.5.5 0 01.5.5z"
      data-name="Path 502"
      fill="#121212"
    />
  </svg>
);

const Bookmark = ({ color1 = "#eee", color2 = "#121212" }) => (
  <svg width="28px" height="28px" viewBox="0 0 28 28">
    <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill={color1} cx="14" cy="14" r="14"></circle>
      <g id="saved-bookmark-outline" transform="translate(8.000000, 6.000000)" fill={color2} fillRule="nonzero">
        <path
          d="M10.5,0 L1.5,0 C0.671572875,0 0,0.671572875 0,1.5 L0,16 L6,12.5 L12,16 L12,1.5 C12,0.671572875 11.3284271,0 10.5,0 Z M10.5,13.388 L6,10.763 L1.5,13.388 L1.5,1.688 C1.50055021,1.5845612 1.58455974,1.501 1.688,1.501 L10.313,1.501 C10.4168295,1.501 10.501,1.58517047 10.501,1.689 L10.5,13.388 Z"
          id="Path_507"
        ></path>
      </g>
    </g>
  </svg>
);
Bookmark.propTypes = {
  color1: string,
  color2: string
};
const Email = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3804" data-name="Group 3804" transform="translate(-179 -383)">
      <g id="Group_3682" data-name="Group 3682" transform="translate(-368 -131)">
        <circle
          id="Ellipse_3"
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(547 514)"
          fill={bgcolor}
        />
        <path
          id="Path_185"
          d="M13.735 67.467A.165.165 0 0 1 14 67.6v5.592a1.313 1.313 0 0 1-1.312 1.308H1.313A1.313 1.313 0 0 1 0 73.188V67.6a.164.164 0 0 1 .265-.129c.612.476 1.425 1.08 4.214 3.106A4.892 4.892 0 0 0 7 71.878a4.894 4.894 0 0 0 2.524-1.3c2.789-2.028 3.598-2.635 4.211-3.111zM7 71c.634.011 1.548-.8 2.007-1.132 3.629-2.633 3.9-2.863 4.741-3.519a.654.654 0 0 0 .252-.517v-.52A1.313 1.313 0 0 0 12.688 64H1.313A1.313 1.313 0 0 0 0 65.313v.52a.658.658 0 0 0 .252.517c.837.654 1.113.886 4.741 3.519C5.452 70.2 6.366 71.011 7 71z"
          className="cls-2"
          data-name="Path 185"
          transform="translate(554 458)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);
Email.propTypes = {
  bgcolor: string,
  color: string
};

const BookmarkActive = () => (
  <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill="#EEE" cx="14" cy="14" r="14" />
      <path
        d="M20 23V8.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0018.5 7h-9c-.417 0-.77.146-1.063.437A1.447 1.447 0 008 8.5V23l6-3.5 6 3.5z"
        fill="#132437"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const Print = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3808" data-name="Group 3808" transform="translate(-383 -383)">
      <g id="Group_3678" data-name="Group 3678" transform="translate(-353 -18)">
        <circle
          id="Ellipse_3"
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(736 401)"
          fill={bgcolor}
        />
        <path
          fill={color}
          id="Path_183"
          d="M12.25 5.25V2.112a.876.876 0 0 0-.256-.619L10.756.256A.875.875 0 0 0 10.137 0H2.625a.875.875 0 0 0-.875.875V5.25A1.75 1.75 0 0 0 0 7v3.063a.437.437 0 0 0 .438.438H1.75v2.625a.875.875 0 0 0 .875.874h8.75a.875.875 0 0 0 .875-.875V10.5h1.313a.437.437 0 0 0 .437-.437V7a1.75 1.75 0 0 0-1.75-1.75zm-1.75 7h-7V9.625h7zm0-6.125h-7V1.75h5.25v1.313a.437.437 0 0 0 .438.438H10.5zm1.313 1.969a.656.656 0 1 1 .656-.656.656.656 0 0 1-.656.656z"
          className="cls-2"
          data-name="Path 183"
          transform="translate(743 408)"
        />
      </g>
    </g>
  </svg>
);
Print.propTypes = {
  bgcolor: string,
  color: string
};
const CopyLink = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3805" data-name="Group 3805" transform="translate(-179 -427)">
      <g id="Group_3675" data-name="Group 3675" transform="translate(-474 -24)">
        <g id="Group_3674" data-name="Group 3674">
          <circle
            id="Ellipse_3"
            cx="14"
            cy="14"
            r="14"
            className="cls-1"
            data-name="Ellipse 3"
            transform="translate(653 451)"
            fill={bgcolor}
          />
        </g>
        <path
          fill={color}
          id="Path_181"
          d="M8.93 5.069a4.154 4.154 0 0 1 .01 5.868l-.01.01-1.837 1.837a4.156 4.156 0 0 1-5.878-5.878L2.23 5.892a.437.437 0 0 1 .746.29 5.039 5.039 0 0 0 .265 1.442.44.44 0 0 1-.1.454l-.358.358a1.969 1.969 0 1 0 2.766 2.8L7.383 9.4a1.968 1.968 0 0 0 0-2.784 2.048 2.048 0 0 0-.283-.235.438.438 0 0 1-.19-.345 1.089 1.089 0 0 1 .32-.815l.576-.576a.439.439 0 0 1 .563-.045 4.167 4.167 0 0 1 .561.47zm3.854-3.854a4.161 4.161 0 0 0-5.878 0L5.069 3.052l-.01.01A4.157 4.157 0 0 0 5.63 9.4a.439.439 0 0 0 .563-.047l.576-.576a1.089 1.089 0 0 0 .32-.815.438.438 0 0 0-.19-.345 2.048 2.048 0 0 1-.283-.234 1.968 1.968 0 0 1 0-2.784l1.837-1.837a1.969 1.969 0 1 1 2.766 2.8l-.358.358a.44.44 0 0 0-.1.454 5.039 5.039 0 0 1 .265 1.442.437.437 0 0 0 .746.29l1.015-1.015a4.161 4.161 0 0 0 0-5.878z"
          className="cls-2"
          data-name="Path 181"
          transform="translate(660 458)"
        />
      </g>
    </g>
  </svg>
);
CopyLink.propTypes = {
  bgcolor: string,
  color: string
};

const Instagram = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3807" data-name="Group 3807" transform="translate(-383 -427)">
      <g id="Group_3679" data-name="Group 3679" transform="translate(-463.747 -168)">
        <circle
          id="Ellipse_3"
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(846.747 595)"
          fill={bgcolor}
        />
      </g>
      <path
        fill={color}
        id="Path_184"
        d="M6.927 35.235a3.589 3.589 0 1 0 3.589 3.589 3.583 3.583 0 0 0-3.589-3.589zm0 5.922a2.333 2.333 0 1 1 2.333-2.334 2.337 2.337 0 0 1-2.333 2.333zm4.573-6.069a.837.837 0 1 1-.837-.837.835.835 0 0 1 .837.837zm2.377.85A4.142 4.142 0 0 0 12.745 33a4.169 4.169 0 0 0-2.933-1.131c-1.156-.066-4.619-.066-5.775 0A4.164 4.164 0 0 0 1.1 33a4.156 4.156 0 0 0-1.126 2.934c-.066 1.156-.066 4.619 0 5.775A4.142 4.142 0 0 0 1.1 44.642a4.175 4.175 0 0 0 2.933 1.131c1.156.066 4.619.066 5.775 0a4.142 4.142 0 0 0 2.933-1.131 4.17 4.17 0 0 0 1.131-2.933c.066-1.156.066-4.616 0-5.772zm-1.493 7.012a2.362 2.362 0 0 1-1.331 1.331 15.426 15.426 0 0 1-4.126.281A15.546 15.546 0 0 1 2.8 44.28a2.362 2.362 0 0 1-1.33-1.331 15.426 15.426 0 0 1-.281-4.126A15.546 15.546 0 0 1 1.47 34.7a2.362 2.362 0 0 1 1.33-1.333 15.426 15.426 0 0 1 4.126-.281 15.546 15.546 0 0 1 4.126.281 2.362 2.362 0 0 1 1.331 1.333 15.426 15.426 0 0 1 .281 4.126 15.417 15.417 0 0 1-.281 4.123z"
        className="cls-2"
        data-name="Path 184"
        transform="translate(390.328 402.175)"
      />
    </g>
  </svg>
);
Instagram.propTypes = {
  bgcolor: string,
  color: string
};

const Linkedin = ({ bgcolor = "#0077b5", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3806" data-name="Group 3806" transform="translate(-179 -471)">
      <g id="Group_3676" data-name="Group 3676" transform="translate(-446 70)">
        <path
          id="Ellipse_3"
          d="M14 0A14 14 0 1 1 0 14 14 14 0 0 1 14 0z"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(625 401)"
          fill={bgcolor}
        />
        <path
          fill={color}
          id="Path_180"
          d="M3.134 14.017H.231V4.671h2.9zM1.681 3.4a1.689 1.689 0 1 1 1.681-1.7 1.7 1.7 0 0 1-1.681 1.7zM14 14.017h-2.9v-4.55c0-1.084-.022-2.475-1.509-2.475-1.509 0-1.74 1.178-1.74 2.4v4.628h-2.9V4.671h2.785v1.275h.041a3.05 3.05 0 0 1 2.746-1.509C13.46 4.436 14 6.371 14 8.883v5.134z"
          className="cls-2"
          data-name="Path 180"
          transform="translate(632 406.982)"
        />
      </g>
    </g>
  </svg>
);
Linkedin.propTypes = {
  bgcolor: string,
  color: string
};
const PublisedTimeToggler = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="up-down" width="7.187" height="10" viewBox="0 0 7.187 10">
    <path
      id="Path_269"
      d="M17.539 62.754h5.978a.6.6 0 0 1 .427 1.03l-2.989 2.989a.6.6 0 0 1-.852 0l-2.992-2.989a.6.6 0 0 1 .428-1.03zm6.405-2.638l-2.989-2.989a.6.6 0 0 0-.852 0l-2.992 2.989a.6.6 0 0 0 .427 1.03h5.978a.6.6 0 0 0 .428-1.03z"
      data-name="Path 269"
      transform="translate(-16.934 -56.95)"
      fill="#999999"
    ></path>
  </svg>
);

export {
  Twitter,
  Facebook,
  Share,
  FontIncrease,
  FontDecrease,
  Bookmark,
  BookmarkActive,
  FacebookIcon,
  TwitterIcon,
  Email,
  Print,
  CopyLink,
  Instagram,
  Linkedin,
  PublisedTimeToggler,
  CommentIcon
};
